import { InjectionToken } from '@angular/core';

export const WS_URL = new InjectionToken('WebSocket URL');
export const accountFeatureKey = 'accountFeature';
